import { arrayMove } from 'react-sortable-hoc';
import LocationsList from './LocationsList';
import { CartSiteAddress } from 'screens/AccessExpressV3/CartProvider';
import showToast from 'components/Toast/Toast';

const Locations = ({
  locations,
  onChange,
}: {
  locations: Array<CartSiteAddress>;
  onChange: (locations: Array<CartSiteAddress>) => void;
}) => {
  const onSortEnd = ({
    oldIndex,
    newIndex,
  }: {
    oldIndex: number;
    newIndex: number;
  }) => {
    if (oldIndex !== newIndex) {
      const newLocations = arrayMove([...locations], oldIndex, newIndex);
      onChange(newLocations);
    }
  };

  const handleChange = (index: number, value?: CartSiteAddress) => {
    const updatedLocations = [...locations];
    if (value === undefined) {
      updatedLocations.splice(index, 1);
    } else {
      // check if already have the location added!
      if (
        locations.some(
          (loc) =>
            (loc.address_line_1 === value.address_line_1 &&
              loc.zip === value.zip) ||
            (Boolean(loc.id) && Boolean(value.id) && loc.id === value.id),
        )
      ) {
        showToast.error({
          message: 'That address is already added!',
          autoClose: true,
        });
        return;
      }
      updatedLocations[index] = value;
    }
    onChange(updatedLocations);
  };

  return (
    <div className="access-locations-wrapper">
      <LocationsList
        items={locations}
        onChange={handleChange}
        onSortEnd={onSortEnd}
        helperClass="z-[9999] !pointer-events-auto"
        distance={1}
        axis="y"
        lockAxis="y"
        useDragHandle
      />
    </div>
  );
};

export default Locations;
